/**
 * The one DOM boundary. Every HTML string produced by the incremental
 * markdown layer, and every highlighted block that comes back from shiki,
 * passes through here before it can reach the document. No exceptions: the
 * renderer in stream-core is pure and explicitly does not promise safe
 * output, and there is a test on each side of that contract.
 */

import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a',
  'blockquote',
  'br',
  'code',
  'del',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'hr',
  'li',
  'ol',
  'p',
  'pre',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'ul',
];

// `style` is admitted for one reason: shiki colours tokens with inline
// styles. DOMPurify still strips url() and expression payloads inside it.
const ALLOWED_ATTR = ['href', 'class', 'style'];

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}
